import { render, staticRenderFns } from "./UpdateCompany.vue?vue&type=template&id=6790a8d0&"
import script from "./UpdateCompany.vue?vue&type=script&lang=js&"
export * from "./UpdateCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports